import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LocaleSetupService } from '@platform-frontend/transloco';
import { TypedChanges } from '@platform-frontend/util';
import { map, Observable, of } from 'rxjs';
import { MobileService } from '../mobile';

@Component({
  selector: 'yat-language-chooser',
  templateUrl: './language-chooser.component.html',
  styleUrls: ['./language-chooser.component.scss']
})
export class LanguageChooserComponent implements OnChanges, OnInit, AfterViewInit {
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private localeSetupService: LocaleSetupService,
    private mobileService: MobileService,
    private translocoService: TranslocoService
  ) {}

  @Input()
  chooser: 'languageChooserLink' | 'languageChooserMobile' = 'languageChooserLink';

  @Input()
  useMobileChooser: boolean = true;

  @Input()
  classNames: string[] = [];

  @Input()
  placement: 'top' | 'bottom' = 'bottom';

  @ViewChild('languageChooserLink')
  languageChooserLinkTemplate: TemplateRef<any> | undefined | null;

  @ViewChild('languageChooserMobile')
  languageChooserMobileTemplate: TemplateRef<any> | undefined | null;

  showLanguageSelector: boolean = false;

  activeLang$: Observable<string>;
  activeLangLabel$: Observable<string | null> = of(null);
  availableLangs: any[];

  readonly MATOMO_EVENT_CATEGORY_LANGUAGE = 'Language';

  template: TemplateRef<any> | null = null;

  ngOnInit(): void {
    this.availableLangs = this.translocoService.getAvailableLangs();
    this.activeLang$ = this.translocoService.langChanges$;
    this.activeLangLabel$ = this.activeLang$.pipe(map(langId => this.availableLangs.find(l => l.id === langId)?.label ?? null));
  }

  ngOnChanges(changes: TypedChanges<LanguageChooserComponent>): void {
    if (changes.chooser) {
      this.setTemplate();
    }
  }

  ngAfterViewInit(): void {
    this.setTemplate();
  }

  private setTemplate(): void {
    if (this.mobileService.isMobileScreenSize() && this.useMobileChooser) {
      this.template = this.languageChooserMobileTemplate ?? null;
    } else {
      this.template = (this.chooser === 'languageChooserLink' ? this.languageChooserLinkTemplate : this.languageChooserMobileTemplate) ?? null;
    }
    this.changeDetectorRef.detectChanges();
  }

  setLang(lang: string): void {
    this.localeSetupService.setLocaleByUser(lang);
    this.toggleLanguageSelector();
  }

  toggleLanguageSelector(): void {
    this.showLanguageSelector = !this.showLanguageSelector;
  }
}
